import { EventEmitter, Injectable } from '@angular/core';
import { interval, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  isLoading$ = new EventEmitter<boolean>();
  loadings: boolean[] = [];

  constructor() {
    interval(500).subscribe(() => {
      const bol = this.loadings.find((l) => l);
      this.isLoading$.next(!!bol);
    });
  }

  loader(obs: Observable<boolean>) {
    const i = this.loadings.length;
    this.loadings.push(false);
    obs.subscribe(loading => {
      this.loadings[i] = loading;
    });
  }
}
